import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermGuidelineCategory from '@/components/TermGuidelineCategory';

const QualityGuidelineNonPSAPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">クオリティガイドライン - シングルカード</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] outline outline-4 outline-offset-[-2px] outline-[#e4e4e4]" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="w-full justify-center text-black text-base leading-7">
              PSAを除くシングルカードは全て「中古」にて出品いただいております。<br/>
              シングルカードを出品する際は、商品のコンディションに応じて「商品状態の選択」と「商品画像のアップロード」が必要です。<br/>
              出品前にお手元の商品状態をよくご確認のうえ、最も適した状態レベルを選んで出品してください。<br/>
              検品時には、掲載された画像・出品情報・選択された商品状態が実物と一致しているかを確認いたします。選択された状態と実際の商品状態に差異がある場合は、鑑定時に購入者様へ取引の継続可否を確認いたします。その結果、取引がキャンセルとなった場合は、商品を着払い（配送料出品者様負担）にて返送いたしますので、あらかじめご了承ください。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] outline outline-4 outline-offset-[-2px] outline-[#e4e4e4]" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">注意事項</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center">
                <span className="text-black text-base leading-7">・状態表に記載されている内容はあくまで一例であり、商品ごとに状態レベルの基準が変動する場合があります。<br/>・掲載されている商品画像は、撮影環境などの影響により、実物と色味が異なって見えることがあります。<br/>・商品の検品時には、選択された商品状態がガイドラインの基準と一致しているかを確認しております。<br/>・補足説明に記載された内容よりも、ガイドラインで定められた基準が優先されます。<br/></span>
                <span className="text-black text-base leading-7">※なお、商品状態にかかわらず、購入者様に誤解を与えるような表現や、出品情報と大きく異なる内容が記載されている場合は、取引がキャンセルとなる可能性があります。</span>
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="w-full justify-center text-black text-base leading-7">すべての出品に共通するルールや、出品情報に関する詳細については、以下のページもあわせて必ずご確認ください。</div>
                <Link to={`/terms/guideline_listing${location.search}`} className="w-full justify-center text-[#00b8f9] text-base underline leading-7 hover:text-[#0099d6]">出品ガイドライン</Link>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] outline outline-4 outline-offset-[-2px] outline-[#e4e4e4]" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">状態表</div>
            </div>
            <img className="self-stretch h-auto" src="/images/terms/guideline_non_psa_1.jpg" alt="状態表" />
            <div className="w-full justify-center text-black text-base leading-7">※複数の状態レベルに当てはまる場合は、該当するうち最も低いレベルから出品してください</div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] outline outline-4 outline-offset-[-2px] outline-[#e4e4e4]" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">商品の状態</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">A（きれいな状態）</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base leading-7">「A」ランクとして出品できるのは、目立つ大きなダメージがなく、全体的に良好な状態を保っている商品に限られます。</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_2.jpg" alt="A ランク例 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_3.jpg" alt="A ランク例 2" />
                </div>
                <div className="w-full justify-center text-black text-base leading-7">製造や流通の過程で生じる可能性のある軽微な裁断跡や、一次流通時から見られる軽度な反りについては、初期仕様の一部と判断しております。<br/>また、以下のような状態も初期仕様として扱い、「A」ランクのガイドライン基準を満たすものといたします。<br/>※ただし、初期仕様に該当する状態であっても、目立つ程度のダメージが確認される場合は「B」ランクとしてご出品ください。</div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・ごく僅かな白欠け</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_4.jpg" alt="ごく僅かな白欠け" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・縦線・横線</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_5.jpg" alt="縦線・横線" />
                </div>
              </div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・製造過程で発生し得るホロ欠け、ホロずれ</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_6.jpg" alt="ホロ欠け、ホロずれ 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_7.jpg" alt="ホロ欠け、ホロずれ 2" />
                </div>
              </div>
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・軽度のホイル抜け</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_8.jpg" alt="軽度のホイル抜け" />
                  <div className='w-1/2 h-auto' />
                </div>
              </div>
            </div>
            
            <div className="w-full h-0.5 relative bg-[#e4e4e4]" />
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">B（小さなキズ/ソリがある品）</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base leading-7">以下のような状態については、複数箇所にわたる場合でも「B」ランクのガイドライン基準を満たすものとして取り扱います。<br/>※ただし、ダメージが広範囲に及ぶ場合は、「C」ランクとしてご出品ください。</div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・数箇所に及ぶ僅かな白欠け</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_9.jpg" alt="数箇所に及ぶ僅かな白欠け" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・浅く小さい凹み、傷</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_10.jpg" alt="浅く小さい凹み、傷" />
                </div>
              </div>
              <div className="self-stretch inline-flex justify-between items-start">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・平面においた状態では目立たない歪み</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_11.jpg" alt="平面においた状態では目立たない歪み" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・一箇所だけに見られる軽度な折れ</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_12.jpg" alt="一箇所だけに見られる軽度な折れ" />
                </div>
              </div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・軽微な反り</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_13.jpg" alt="軽微な反り 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_14.jpg" alt="軽微な反り 2" />
                </div>
              </div>
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・軽度のめくれ</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_15.jpg" alt="軽度のめくれ" />
                  <div className="w-1/2 h-auto" />
                </div>
              </div>
            </div>
            
            <div className="w-full h-0.5 relative bg-[#e4e4e4]" />
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">C（中程度の傷/ソリあり）</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base leading-7">プレイ使用に伴うキズやめくれなどが複数箇所に確認できる商品は、「C」ランクを選択してください。</div>
                <div className="w-full justify-center text-black text-base leading-7">以下のような状態については、複数箇所にわたる場合でも「C」ランクのガイドライン基準を満たすものとして取り扱います。</div>
              </div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・広範囲に及ぶ白欠け・めくれ</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_16.jpg" alt="広範囲に及ぶ白欠け・めくれ 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_17.jpg" alt="広範囲に及ぶ白欠け・めくれ 2" />
                </div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_18.jpg" alt="広範囲に及ぶ白欠け・めくれ 3" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_19.jpg" alt="広範囲に及ぶ白欠け・めくれ 4" />
                </div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・一目でわかる歪み</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_20.jpg" alt="一目でわかる歪み" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・大きく目立つ折れ</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_21.jpg" alt="大きく目立つ折れ" />
                </div>
              </div>
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・広範囲に及ぶ傷、凹凸の目立つ傷</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_22.jpg" alt="広範囲に及ぶ傷、凹凸の目立つ傷" />
                  <div className="w-1/2 h-auto" />
                </div>
              </div>
            </div>
            
            <div className="w-full h-0.5 relative bg-[#e4e4e4]" />
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">D（大きなダメージあり）</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base leading-7">全体的に強い使用感が見られる商品は、「D」ランクを選択してください。</div>
                <div className="w-full justify-center text-black text-base leading-7">カードの日焼けや、以下に該当するような状態については、複数箇所に及ぶ場合でも「D」ランクのガイドライン基準を満たすものとして出品可能です。<br/>ただし、書き込み等のデザインを損なう汚れやインクド、重度の欠けや汚れや破れ、トリミング（初期仕様ではないカードの切断跡）、広範囲にわたる重度な水濡れや飲食物の付着跡が見られる場合は「D」でも出品することができません。</div>
              </div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・複数箇所に及ぶ、大きく目立つ凹凸・中程度の傷</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_23.jpg" alt="複数箇所に及ぶ、大きく目立つ凹凸・中程度の傷 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_24.jpg" alt="複数箇所に及ぶ、大きく目立つ凹凸・中程度の傷 2" />
                </div>
              </div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base font-bold leading-7">・デザインに影響する大きな折れ・重度のめくれ</div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_25.jpg" alt="デザインに影響する大きな折れ・重度のめくれ 1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_26.jpg" alt="デザインに影響する大きな折れ・重度のめくれ 2" />
                </div>
                <div className="w-full h-auto inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_non_psa_27.jpg" alt="デザインに影響する大きな折れ・重度のめくれ 3" />
                  <div className="w-1/2 h-auto" />
                </div>
              </div>
            </div>
            
            <div className="w-full h-0.5 relative bg-[#e4e4e4]" />
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">取り扱いランク外</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="w-full justify-center text-black text-base leading-7">飲食物の付着跡や書き込みなど、カードのデザインを損なう汚れ、重度の欠け・破れが確認される場合、または以下に該当するような状態がある場合には、「D」ランクであっても出品することはできません。</div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・重度の折れ</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_28.jpg" alt="重度の折れ" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・広範囲にわたる重度な水濡れ</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_29.jpg" alt="広範囲にわたる重度な水濡れ" />
                </div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・トリミング(初期仕様ではないカードの切断跡)</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_non_psa_30.jpg" alt="トリミング(初期仕様ではないカードの切断跡)" />
                </div>
                <div className="w-[30px]" />
                <div className="inline-flex flex-col justify-start items-start gap-2.5 flex-1">
                  <div className="justify-center text-black text-base font-bold leading-7">・インクド</div>
                  <div className="w-full h-auto relative overflow-hidden">
                    <img className="w-full h-auto" src="/images/terms/guideline_non_psa_31.jpg" alt="インクド" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <TermGuidelineCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelineNonPSAPage;